module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/K099Fx/tc-custom/9781488086946.jpg?1726617345531",
      "alt": "This image is the cover for the book Lady Olivia and the Infamous Rake, The Beauchamp Heirs"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lady Olivia and the Infamous Rake, The Beauchamp Heirs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("How utterly mortifying to be rejected by a rake!")]), _c('br'), _c('br'), _vm._v("Sneaking off to Vauxhall Gardens lands Lady Olivia Beauchamp in a bit more trouble than she expected—but after being plucked from peril by resolute bachelor Lord Hugo Alastair, she is secretly outraged that he doesn’t even try to steal a kiss! He’s a notorious rake among the ton, and as a result, utterly forbidden to an innocent debutante like her—the daughter of a duke, no less. But their attraction is magnetic. Will she risk her reputation for a passionate encounter?"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for the romances of Janice Preston")]), _c('br'), _c('br'), _vm._v("“One of the deepest, most lovable heroes I’ve read about in quite some time.” —"), _c('i', [_vm._v("All About Romance")]), _c('br'), _c('br'), _vm._v("“A captivating, sweet tale.” —"), _c('i', [_vm._v("RT Book Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Janice Preston\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0